var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Plain',{attrs:{"title":"Legal"}},[_c('div',{attrs:{"slot":"page_body"},slot:"page_body"},[_vm._v("\n    [text goes here]\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74c2bd4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/legal.vue
// module id = null
// module chunks = 